import { Component, OnInit } from '@angular/core'

@Component({
    selector: './slot-menu',
    templateUrl: './slot-menu.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class SlotMenuComponent implements OnInit {

    ngOnInit() {

    }
}